import KunLoading118 from './src/index'

KunLoading118.install = function (Vue) {
	Vue.component(KunLoading118.name, KunLoading118);
}

export default KunLoading118;
